// extracted by css-extract-rspack-plugin
export default {"CloseButton":"HD9hK","HeaderTitleContainer":"GJ9Zy","backButton":"Ia1C1","defaultBackButton":"Sfkgh"};